import { useEffect, useRef, useState } from "react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function LazyHomeSection({
  children,
  fallback,
  rootMargin = "280px 0px",
  minHeight,
}) {
  const ref = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (typeof IntersectionObserver === "undefined") {
      setShouldLoad(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { rootMargin, threshold: 0.01 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin]);

  useEffect(() => {
    if (shouldLoad) {
      requestAnimationFrame(() => ScrollTrigger.refresh());
    }
  }, [shouldLoad]);

  return (
    <div ref={ref} className="w-full" style={minHeight ? { minHeight } : undefined}>
      {shouldLoad ? children : fallback}
    </div>
  );
}
